import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { RequireAuth, RequirePermission, NoAccess } from './router-utils';
import Login from './components/Login';
import AppLayout from './components/AppLayout';
import Dashboard from './components/Dashboard';
import Reservations from './components/Reservations';
import ReservationDetails from './components/ReservationDetails';
import Cleaning from './components/Cleaning';
import Expenses from './components/Expenses';
import EmailImport from './components/EmailImport';
import Agent from './components/Agent';
import Changelog from './components/Changelog';
import PortalTodo from './components/PortalTodo';
import UsersAdmin from './components/UsersAdmin';
import Billing from './components/Billing';
import GuestMessages from './components/GuestMessages';
import Finance from './components/Finance';
import Nuki from './components/Nuki';
import Health from './components/Health';
import { firstAllowedPath } from './permissions';

function IndexRedirect() {
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  return <Navigate to={firstAllowedPath(user)} replace />;
}

function PageTitle() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const title = (() => {
      if (path === '/login') return 'Logowanie · Hermes Rental Portal';
      if (path === '/brak-dostepu') return 'Brak dostępu · Hermes Rental Portal';
      if (path === '/' || path === '/dashboard') return 'Start · Hermes Rental Portal';
      if (path === '/rezerwacje') return 'Rezerwacje · Hermes Rental Portal';
      if (path.startsWith('/rezerwacje/')) return 'Szczegóły rezerwacji · Hermes Rental Portal';
      if (path === '/sprzatanie') return 'Sprzątanie · Hermes Rental Portal';
      if (path.startsWith('/sprzatanie/')) return `Sprzątanie #${decodeURIComponent(path.split('/').pop() || '')} · Hermes Rental Portal`;
      if (path === '/zakupy') return 'Zakupy i zwroty · Hermes Rental Portal';
      if (path === '/rachunki') return 'Rachunki · Hermes Rental Portal';
      if (path === '/wiadomosci') return 'Wiadomości gości · Hermes Rental Portal';
      if (path === '/import') return 'Telefon / Pulse i import · Hermes Rental Portal';
      if (path === '/agent') return 'Agent · Hermes Rental Portal';
      if (path === '/uzytkownicy') return 'Użytkownicy · Hermes Rental Portal';
      if (path === '/zmiany') return 'Zmiany · Hermes Rental Portal';
      if (path === '/pomysly') return 'Pomysły do launchu · Hermes Rental Portal';
      if (path === '/finanse') return 'Finanse · Hermes Rental Portal';
      if (path === '/nuki') return 'Nuki · Hermes Rental Portal';
      if (path === '/health') return 'Health · Hermes Rental Portal';
      return 'Hermes Rental Portal';
    })();
    document.title = title;
  }, [location.pathname]);

  return null;
}

// Main router component
export default function Router() {
  return (
    <BrowserRouter>
      <PageTitle />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/brak-dostepu" element={<NoAccess />} />
        
        <Route path="/" element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }>
          <Route index element={<IndexRedirect />} />
          <Route path="dashboard" element={<RequireAuth role="admin"><Dashboard /></RequireAuth>} />
          <Route path="rezerwacje" element={<RequirePermission permission="reservations"><Reservations /></RequirePermission>} />
          <Route path="rezerwacje/:bookingRef" element={<RequirePermission permission="reservations"><ReservationDetails /></RequirePermission>} />
          <Route path="sprzatanie" element={<RequirePermission permission="cleaning"><Cleaning /></RequirePermission>} />
          <Route path="sprzatanie/:jobId" element={<RequirePermission permission="cleaning"><Cleaning /></RequirePermission>} />
          <Route path="zakupy" element={<RequirePermission permission="expenses"><Expenses /></RequirePermission>} />
          <Route path="rachunki" element={
            <RequirePermission permission="billing">
              <Billing />
            </RequirePermission>
          } />
          <Route path="wiadomosci" element={
            <RequirePermission permission="messages">
              <GuestMessages />
            </RequirePermission>
          } />
          <Route path="import" element={
            <RequirePermission permission="integrations">
              <EmailImport />
            </RequirePermission>
          } />
          <Route path="agent" element={
            <RequirePermission permission="agent">
              <Agent />
            </RequirePermission>
          } />
          <Route path="uzytkownicy" element={
            <RequirePermission permission="users">
              <UsersAdmin />
            </RequirePermission>
          } />
          <Route path="zmiany" element={<Changelog />} />
          <Route path="pomysly" element={
            <RequireAuth role="admin">
              <PortalTodo />
            </RequireAuth>
          } />
          <Route path="finanse" element={<RequirePermission permission="finance"><Finance /></RequirePermission>} />
          <Route path="nuki" element={
            <RequirePermission permission="nuki">
              <Nuki />
            </RequirePermission>
          } />
          <Route path="health" element={
            <RequirePermission permission="health">
              <Health />
            </RequirePermission>
          } />
        </Route>
        
        {/* Catch all unmatched routes */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}